import { BCMSDate, BrandingStyle, DisabledPrompt, Link, useModel } from "@bcm-dev/bcms-vite";
import React from "react";
import "./styles.css";
import "./mobile.css";

/**
 * @function EDEStatementsPageFooterView
 * @returns {React.Component}
 * @example
 * <EDEStatementsPageFooterView text="FDIC Insured | Copyright 20XX">
 *  <p>This is inside the page footer.</p>
 * </EDEStatementsPageFooterView>
 */
export default function EDEStatementsPageFooterView(props) {
  const branding = useModel().branding.options;

  // Create all footer links based on what is set in branding
  const links = branding.footer_links_abi22.split(", ")
    .map((link, index) => <FooterLink key={ `Link_${ index }` } label={ link } />, []);
  // Get the message set in branding for the footer
  const text = branding.footer_message_abi22;
  const copyrightYear = BCMSDate.init().format("Y");
  const copyrightMessage = `Copyright ©${ copyrightYear } Beavercreek Marketing. All Rights Reserved.`;

  return (
    <BrandingStyle style={ undefined } className="ede-statements-page-footer-view text-center flex-container flex-vertical">

        <div className="flex-container flex-horizontal all-center link-container">
          
        </div>
        <BrandingStyle style={ undefined } className="flex-height flex-container flex-horizontal all-center text-container">
          <div className="flex-container flex-horizontal align-center">{ copyrightMessage }</div>
        </BrandingStyle>
    </BrandingStyle>
    
  );
}

/**
 * @function FooterLink
 * @param {STRING} label - Sets the text of the link
 * @returns {React.Component}
 * @description Disabled link to use to map over links set in branding
 * @example
 * <FooterLink label="Test" />
 */
function FooterLink({ label }) {
  return (
    <DisabledPrompt>
      <Link to="/">{ label }</Link>
    </DisabledPrompt>
  );
}